import { type MaintenanceChecklistSection } from '@gb-ticket/shared-types';

import { cn } from '@/lib/utils';
import { MAINTENANCE_PROTOCOL_COLUMN_CLASS } from '@/products/maintenance/features/protocol/protocol-wizard-layout';

export function ProtocolWizardProgress({
  sections,
  step,
  isSummary,
  onSelectStep,
}: {
  sections: MaintenanceChecklistSection[];
  step: number;
  isSummary: boolean;
  onSelectStep: (index: number) => void;
}) {
  const totalSections = sections.length;
  const progress = isSummary ? 1 : totalSections > 0 ? (step + 1) / totalSections : 0;
  const currentTitle = isSummary ? 'Zusammenfassung' : (sections[step]?.title ?? '');

  return (
    <div className={cn('w-full space-y-2', MAINTENANCE_PROTOCOL_COLUMN_CLASS)}>
      <p className="text-sm text-muted-foreground">
        {isSummary
          ? 'Zusammenfassung'
          : `Abschnitt ${step + 1} von ${totalSections}${currentTitle ? ` · ${currentTitle}` : ''}`}
      </p>
      <div
        className="h-1.5 w-full overflow-hidden rounded-full bg-muted"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(progress * 100)}
      >
        <div
          className="h-full rounded-full bg-primary transition-[width]"
          style={{ width: `${Math.min(100, Math.max(0, progress * 100))}%` }}
        />
      </div>
      <div className="hidden gap-3 overflow-x-auto text-sm whitespace-nowrap sm:flex">
        {sections.map((section, index) => (
          <button
            key={section.id}
            type="button"
            className={cn(
              'shrink-0 border-b-2 border-transparent pb-1 transition-colors',
              index === step && !isSummary
                ? 'border-primary font-medium text-foreground'
                : 'text-muted-foreground hover:text-foreground',
            )}
            onClick={() => onSelectStep(index)}
          >
            {section.title}
          </button>
        ))}
        <button
          type="button"
          className={cn(
            'shrink-0 border-b-2 border-transparent pb-1 transition-colors',
            isSummary
              ? 'border-primary font-medium text-foreground'
              : 'text-muted-foreground hover:text-foreground',
          )}
          onClick={() => onSelectStep(sections.length)}
        >
          Zusammenfassung
        </button>
      </div>
    </div>
  );
}
